// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/BG_Brick.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:opsz@9..40&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  box-sizing: border-box;
}

* {
  box-sizing: inherit;
  margin: 0;
  padding: 0;
  font-family: inherit;
  color: inherit;
}
*::before, *::after {
  box-sizing: inherit;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

li {
  list-style: none;
}
li ul, li ol {
  margin: 0;
  padding: 0;
}

img, video {
  max-width: 100%;
}

img {
  object-fit: cover;
}

:root {
  --brown: #b9715b;
  --white: #f8f8f8;
  --blue-dark: #143642;
  --blue-light: #0F8B8D;
  --plum: #6D213C;
  --black: #211A1E;
  font-family: "DM Sans", sans-serif;
  color: var(--white);
  background-color: var(--brown);
}

h1, h2, h3 {
  font-family: "DM Sans", sans-serif;
  font-size: 4rem;
}

svg {
  fill: var(--white);
  width: 2rem;
}

body {
  --margin: 1rem;
  display: grid;
  place-items: center;
  height: var(--doc-height);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-size: 0.9rem;
  line-height: 1.4rem;
}

main {
  display: grid;
  row-gap: 1.6rem;
  grid-template-columns: repeat(2, auto);
  grid-template-rows: 1fr min-content;
}

main #logo {
  grid-column: span 2;
  width: 100%;
  filter: drop-shadow(0px 4px 2px rgba(0, 0, 0, 0.18));
}

main .svg-container {
  display: flex;
  justify-content: end;
  gap: 0.8rem;
}

.icon-link {
  display: flex;
  cursor: pointer;
  transition: transform 0.15s;
}
.icon-link:hover {
  transform: scale(1.08);
}

.inline-link {
  text-decoration: none;
}
.inline-link:hover {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/sass/globals/_reset.scss","webpack://./src/sass/style.scss","webpack://./src/sass/globals/_theme.scss","webpack://./src/sass/layout/_root.scss"],"names":[],"mappings":"AAEA;EACE,sBAAA;ACAF;;ADGA;EACE,mBAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EACA,cAAA;ACAF;ADCE;EACI,mBAAA;ACCN;;ADKA;EACE,yBAAA;EACA,iBAAA;ACFF;;ADKA;EACE,gBAAA;ACFF;ADGE;EACI,SAAA;EACA,UAAA;ACDN;;ADKA;EACE,eAAA;ACFF;;ADKA;EACE,iBAAA;ACFF;;AChCA;EACE,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EAEA,kCAAA;EACA,mBAAA;EACA,8BAAA;ADkCF;;AC/BA;EACE,kCAAA;EACA,eAAA;ADkCF;;AC/BA;EACE,kBAAA;EACA,WAAA;ADkCF;;AEzDA;EACE,cAAA;EAEA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yDAAA;EAGA,iBAAA;EACA,mBAAA;AFyDF;;AEtDA;EACE,aAAA;EAGA,eAAA;EACA,sCAAA;EACA,mCAAA;AFuDF;;AEpDA;EACE,mBAAA;EACA,WAAA;EACA,oDAAA;AFuDF;;AEpDA;EACE,aAAA;EACA,oBAAA;EACA,WAAA;AFuDF;;AEpDA;EACE,aAAA;EACA,eAAA;EAIA,2BAAA;AFoDF;AEvDE;EACE,sBAAA;AFyDJ;;AEpDA;EACE,qBAAA;AFuDF;AEtDE;EACE,0BAAA;AFwDJ","sourcesContent":["// global behavior\n\nhtml {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n  margin: 0;\n  padding: 0;\n  font-family: inherit;\n  color: inherit;\n  &::before, &::after {\n      box-sizing: inherit;\n  }\n}\n\n// specific element styles\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\nli {\n  list-style: none;\n  ul, ol {\n      margin: 0;\n      padding: 0;\n  }\n}\n\nimg, video {\n  max-width: 100%;\n}\n\nimg {\n  object-fit: cover;\n}","@import url(\"https://fonts.googleapis.com/css2?family=DM+Sans:opsz@9..40&display=swap\");\nhtml {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n  margin: 0;\n  padding: 0;\n  font-family: inherit;\n  color: inherit;\n}\n*::before, *::after {\n  box-sizing: inherit;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\nli {\n  list-style: none;\n}\nli ul, li ol {\n  margin: 0;\n  padding: 0;\n}\n\nimg, video {\n  max-width: 100%;\n}\n\nimg {\n  object-fit: cover;\n}\n\n:root {\n  --brown: #b9715b;\n  --white: #f8f8f8;\n  --blue-dark: #143642;\n  --blue-light: #0F8B8D;\n  --plum: #6D213C;\n  --black: #211A1E;\n  font-family: \"DM Sans\", sans-serif;\n  color: var(--white);\n  background-color: var(--brown);\n}\n\nh1, h2, h3 {\n  font-family: \"DM Sans\", sans-serif;\n  font-size: 4rem;\n}\n\nsvg {\n  fill: var(--white);\n  width: 2rem;\n}\n\nbody {\n  --margin: 1rem;\n  display: grid;\n  place-items: center;\n  height: var(--doc-height);\n  background-image: url(\"~/src/assets/BG_Brick.jpg\");\n  font-size: 0.9rem;\n  line-height: 1.4rem;\n}\n\nmain {\n  display: grid;\n  row-gap: 1.6rem;\n  grid-template-columns: repeat(2, auto);\n  grid-template-rows: 1fr min-content;\n}\n\nmain #logo {\n  grid-column: span 2;\n  width: 100%;\n  filter: drop-shadow(0px 4px 2px rgba(0, 0, 0, 0.18));\n}\n\nmain .svg-container {\n  display: flex;\n  justify-content: end;\n  gap: 0.8rem;\n}\n\n.icon-link {\n  display: flex;\n  cursor: pointer;\n  transition: transform 0.15s;\n}\n.icon-link:hover {\n  transform: scale(1.08);\n}\n\n.inline-link {\n  text-decoration: none;\n}\n.inline-link:hover {\n  text-decoration: underline;\n}","// font declarations\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz@9..40&display=swap');\n\n:root {\n  --brown: #b9715b;\n  --white: #f8f8f8;\n  --blue-dark: #143642;\n  --blue-light: #0F8B8D;\n  --plum: #6D213C;\n  --black: #211A1E;\n\n  font-family: \"DM Sans\", sans-serif;\n  color: var(--white);\n  background-color: var(--brown);\n}\n\nh1, h2, h3 {\n  font-family: \"DM Sans\", sans-serif;\n  font-size: 4rem;\n}\n\nsvg {\n  fill: var(--white);\n  width: 2rem;\n}","body {\n  --margin: 1rem;\n\n  display: grid;\n  place-items: center;\n  height: var(--doc-height);\n  background-image: url(\"~/src/assets/BG_Brick.jpg\");\n\n\n  font-size: .9rem;\n  line-height: 1.4rem;\n}\n\nmain {\n  display: grid;\n  // width: calc(var(--doc-width) - 2 * var(--margin));\n  // height: calc((var(--doc-width) - 2 * var(--margin)) * 3 / 4);\n  row-gap: 1.6rem;\n  grid-template-columns: repeat(2, auto);\n  grid-template-rows: 1fr min-content;\n}\n\nmain #logo {\n  grid-column: span 2;\n  width: 100%;\n  filter: drop-shadow(0px 4px 2px rgba(0,0,0,0.18));\n}\n\nmain .svg-container {\n  display: flex;\n  justify-content: end;\n  gap: .8rem;\n}\n\n.icon-link {\n  display: flex;\n  cursor: pointer;\n  &:hover {\n    transform: scale(1.08)\n  }\n  transition: transform 0.15s;\n}\n\n.inline-link {\n  text-decoration: none;\n  &:hover {\n    text-decoration: underline\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
